import { useEffect, useState } from "react";
import { CargoAIDrawer } from "./Drawer";

export const DrawerControl = ({
	handleUseData,
	shouldHideDrawer,
	data,
	handleRemoveBox,
}) => {
	const [localData, setLocalData] = useState(data);

	useEffect(() => {
		setLocalData(data);
	}, [data]);

	const dataFilter = ({ query }) => {
		if (query.trim().toLowerCase() === "") {
			setLocalData(data);
			return;
		}

		const filteredData = localData.filter((cargo) => {
			return (
				cargo.loadingAddressCity
					.toLowerCase()
					.includes(query.trim().toLowerCase()) ||
				cargo.loadingAddressCountry
					.toLowerCase()
					.includes(query.trim().toLowerCase()) ||
				cargo.loadingAddressZip
					.toLowerCase()
					.includes(query.trim().toLowerCase()) ||
				cargo.unloadingAddressCity
					.toLowerCase()
					.includes(query.trim().toLowerCase()) ||
				cargo.unloadingAddressCountry
					.toLowerCase()
					.includes(query.trim().toLowerCase()) ||
				cargo.unloadingAddressZip
					.toLowerCase()
					.includes(query.trim().toLowerCase())
			);
		});

		setLocalData(filteredData);
	};

	return (
		<CargoAIDrawer
			handleUseData={handleUseData}
			handleRemove={handleRemoveBox}
			shouldHideDrawer={shouldHideDrawer}
			data={localData}
			dataFilter={dataFilter}
		/>
	);
};
